import React from 'react';
import { getInlineStyles } from '../../store/designStore';
import styles from './HeroTitle.module.scss';

const HeroTitle = ({ titleConfig }) => {
    if (!titleConfig?.hasTitle) return null;
    return (
        <>
            {titleConfig.text && (
                <h1
                    className={`fw-bold display-5 mb-2 ${styles.titleText}`}
                    style={getInlineStyles(titleConfig.textStyle)}
                >
                    {titleConfig.text}
                </h1>
            )}
            {titleConfig.subtitleText && (
                <p
                    className={`lead mb-0 d-none d-sm-block ${styles.subtitleText}`}
                    style={getInlineStyles(titleConfig.subtitleStyle)}
                >
                    {titleConfig.subtitleText}
                </p>
            )}
        </>
    );
};

export default HeroTitle;
